import React, {useState, useEffect, Fragment} from "react" ;
import {useRecoilValue} from "recoil";
import { getDataFromResponse } from "root/DataFunctions/BaseDataFns";
import {getContactMessages} from "root/DataFunctions/MessageDataFns";
import ChildMessageTable from "root/Tables/ChildMessageTable";
import {childDetailsState} from "root/recoil/childDetailsState";
import {MessageFilters, MessageType} from "root/DataFunctions/Constants";
import useModalAddPost from "root/Modals/AddPost/useModalAddPost";

const SentMessages = (props) => {
    const [messages, setMessages] = useState("");
    const [loading, setLoading] = useState(false);
    const childDetails = useRecoilValue(childDetailsState)

    const shouldShowToDropdown = true;

    const [renderAddMessagingModal, showAddMessagingModal] = useModalAddPost((result) =>
    {
        if(result === "saved") {
            handleGetDraftMessages();
        }
    })

    const handleShowMessage = (message, mode, page) => {
        const child_uid = childDetails && mode !=='edit' ? childDetails[0].adoptee_user_id : message.unenc_recipient_user_id;
        showAddMessagingModal(mode, child_uid, message.post_id, shouldShowToDropdown, MessageType.MESSAGE_TYPE_MESSAGE, page);
    }

    const handleGetDraftMessages = () => {
        setLoading(true);

        getContactMessages( 'user', 'user', MessageFilters.DRAFT, MessageType.MESSAGE_TYPE_MESSAGE, (response) =>
        {
            setMessages(getDataFromResponse(response));
            setLoading(false);
        })
    }

    useEffect(() => {
        handleGetDraftMessages();
    }, []);

    return (
        <>
            <div style={{flex: "1"}}>
                <div className="child_breadcrumb child_breadcrumb-main">
                    <div className="child_breadcrumb_inner">
                        <h2 className="child_breadcrumb_title">Draft Messages</h2>
                    </div>
                </div>

                <div className="child-message-wrap">
                    <div className="child-message-table">
                        {messages && 
                            <ChildMessageTable
                                tableClass='passport-table-child'
                                loading={loading}
                                data={messages}
                                page="draft"
                                showMessageDetail={handleShowMessage}
                            />
                        }  
                    </div>
                </div>
            </div>

            {renderAddMessagingModal(props)}
        </>
    );
}

export default SentMessages;
